import {
  TREQUEST_CUTBANK_IN_ACTIVITY_LOG,
  TREQUEST_CUTBANK_IN_TRANSACTION_LOG,
  TREQUEST_GET_CUTBANK_SUBJECTS,
  TRESPONSE_CUTBANK_IN_ACTIVITY_LOG,
  TRESPONSE_CUTBANK_IN_TRANSACTION_LOG,
  TRESPONSE_GET_CUTBANK_SUBJECTS,
  TUserPaginationOption,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TCutbankInActionType } from './cutbank-in-db.models';

export class GetSubjects implements Action {
  readonly type = TCutbankInActionType.GetSubjectList;
  constructor() {}
}

export class GetSubjectsSuccess implements Action {
  readonly type = TCutbankInActionType.GetSubjectListSuccess;
  constructor(public cutbankInRes: TRESPONSE_GET_CUTBANK_SUBJECTS) {}
}

export class GetSubjectsFailure implements Action {
  readonly type = TCutbankInActionType.GetSubjectListFailure;
  constructor() {}
}

export class GetTransactionLog implements Action {
  readonly type = TCutbankInActionType.GetTransactionLog;
  constructor(public payload: TREQUEST_CUTBANK_IN_TRANSACTION_LOG) {}
}

export class GetTransactionLogSuccess implements Action {
  readonly type = TCutbankInActionType.GetTransactionLogSuccess;
  constructor(public transactionLog: TRESPONSE_CUTBANK_IN_TRANSACTION_LOG) {}
}

export class GetTransactionLogFailure implements Action {
  readonly type = TCutbankInActionType.GetTransactionLogFailure;
  constructor() {}
}

export class GetActivityLog implements Action {
  readonly type = TCutbankInActionType.GetActivityLog;
  constructor(public payload: TREQUEST_CUTBANK_IN_ACTIVITY_LOG) {}
}

export class GetActivityLogSuccess implements Action {
  readonly type = TCutbankInActionType.GetActivityLogSuccess;
  constructor(public activityLog: TRESPONSE_CUTBANK_IN_ACTIVITY_LOG) {}
}

export class GetActivityLogFailure implements Action {
  readonly type = TCutbankInActionType.GetActivityLogFailure;
  constructor() {}
}

export class IsComponentBundleScanEnabled implements Action {
  readonly type = TCutbankInActionType.IsComponentBundleScanEnabled;
  constructor() {}
}

export class IsComponentBundleScanEnabledSuccess implements Action {
  readonly type = TCutbankInActionType.IsComponentBundleScanEnabledSuccess;
  constructor(public isComponentBundleScanEnabled: boolean) {}
}

export type TCutbankInActions =
  | GetSubjects
  | GetSubjectsSuccess
  | GetSubjectsFailure
  | GetTransactionLog
  | GetTransactionLogSuccess
  | GetTransactionLogFailure
  | GetActivityLog
  | GetActivityLogSuccess
  | GetActivityLogFailure
  | IsComponentBundleScanEnabled
  | IsComponentBundleScanEnabledSuccess;
